module.exports = __webpack_public_path__ + "media/images/icons/filled/insurance-f8a38a87e0f5b2771f03c8735f9949dd.svg";